import { smallDateFormat } from "../../utils/Utils";

export function organizarInformacoes(body) {
  let incompany = [];
  let old_incompany = [];

  // Processa as informações da chave "incompany_new"
  if (body && body.incompany_new) {
    body.incompany_new.map(elem => {
      incompany.push({
          id_company: elem.id_company || 0,
          status: elem?.status || 0,
          created_at: smallDateFormat(elem?.created_at) || "2000-01-01 00:00:01" , 
          name: elem?.incompany?.name || "Não Encontrado"
        })
      })
    }
  // Processa as informações da chave "aluno"
  if (body && body.empresa_antigo ) {
    if(body.empresa_antigo.aluno) {
      body.empresa_antigo.aluno.forEach(item => {
        old_incompany.push({
          id_company: item.id_empresa,
          name: item.empresa.nome,
          ativo: item.ativo,
          type: "aluno"
          });
    });

    }
    if(body.empresa_antigo.aluno) {
      body.empresa_antigo.aluno.forEach(item => {
        old_incompany.push({
          id_company: item.id_empresa,
          name: item.empresa.nome,
          status: item.ativo,
          type: "gestor"
          });
    });

    }
  }  
  return {
    incompany: incompany || [],
    old_incompany: old_incompany || []
  };

}

export function orderByDate(data) {
  // Utilizamos o método sort() para ordenar o array com base na data
  data.sort((a, b) => {
    // Convertemos as strings de data em objetos Date para comparação
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    
    // Comparamos as datas e retornamos um valor negativo, zero ou positivo
    // para indicar se a data de a é anterior, igual ou posterior à data de b
    return dateA - dateB;
  });

  return data;
};

export default {organizarInformacoes,orderByDate};